module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/DarkThe.c4e500b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/DarkThe.jpg
// module id = ooU4
// module chunks = 0